import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { api } from "@/lib/api";
import { DecorativeDivider, OmMark, LotusDivider, SriYantra } from "@/components/Ornaments";

export default function KnowledgeArticle() {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);

  useEffect(() => {
    api.get(`/content/knowledge/${slug}`).then(({ data }) => setArticle(data)).catch(() => setArticle(false));
  }, [slug]);

  if (article === null) return <div className="container-x section">Loading...</div>;
  if (article === false) return <div className="container-x section">Article not found.</div>;

  return (
    <div data-testid={`knowledge-article-${slug}`}>
      <section className="relative min-h-[50vh] flex items-end overflow-hidden">
        <img src={article.image_url} alt={article.title} className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 hero-overlay" />
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
          <SriYantra size={460} className="text-[#f3d7a8]" opacity={0.1} />
        </div>
        <div className="container-x relative z-10 py-14 text-[#faf8f5]">
          <Link to="/knowledge" className="inline-flex items-center gap-1 text-[11px] uppercase tracking-[0.22em] opacity-80 hover:opacity-100" data-testid="back-to-knowledge">
            <ChevronLeft size={14} /> Knowledge Hub
          </Link>
          <div className="mt-4 flex items-center gap-3 text-[#f3d7a8]">
            <OmMark size={26} className="text-[#f3d7a8]" />
            <span className="italic-serif text-base">From the Sacred Texts</span>
          </div>
          <h1 className="mt-3 font-heading text-4xl md:text-6xl tracking-display max-w-3xl leading-[1.02]">{article.title}</h1>
        </div>
      </section>

      <section className="section bg-manuscript">
        <div className="container-narrow">
          <DecorativeDivider label="Summary" className="mb-5 justify-start" />
          <p className="text-lg md:text-xl opacity-90 italic-serif leading-[1.7]">{article.summary}</p>
          <div className="gilt-rule my-8 w-24" />
          <div className="leading-[1.95] text-[color:var(--ink-2)] text-[16px] md:text-[17px] whitespace-pre-line drop-cap">{article.body}</div>
        </div>
      </section>
      <LotusDivider className="py-10 bg-paper" />
    </div>
  );
}
